import { render, staticRenderFns } from "./TurnstileWidget.vue?vue&type=template&id=0d2a7a97&scoped=true"
import script from "./TurnstileWidget.vue?vue&type=script&lang=ts"
export * from "./TurnstileWidget.vue?vue&type=script&lang=ts"
import style0 from "./TurnstileWidget.vue?vue&type=style&index=0&id=0d2a7a97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2a7a97",
  null
  
)

export default component.exports